<header>
  <div class="headerRow pad-lr clearfix">
    <div class="brandLogo">
      <button class="buttonBrand" (click)="goBack()">
        <img src="/assets/img/moglix-logo.jpg" width="120" />
      </button>
      <button mat-button *ngIf="currentRoute !== '/category-discovery'" class="btn-basic btn-rectangle btn-md menu-btn" (click)="toggleDropdown()" color="Black">  <i class="ri-menu-2-line"></i></button>
    <div class="tab-menu" *ngIf="isDropdownOpen">
      <mat-tab-group class="outline-tab red-tab dropdown-tab" animationDuration="0ms" mat-align-tabs="start">
        <!-- <mat-tab>
          <ng-template mat-tab-label>
         
           Category List
          </ng-template>
          <ng-container >
            <ul class="category-list">
              <li>
            <img src="assets/img/taparia.png" alt="" />
            Taparia
              </li>
            </ul>
          </ng-container>
        </mat-tab> -->
        <mat-tab>
          <ng-template mat-tab-label>
       
            Brand List
          </ng-template>
          <ul class="category-list">
            <li *ngFor="let brandData of brandListData">
              <img src="{{imgPrefix}}{{brandData?.brandImages?.logo?.links?.logo}}" alt="" onerror="this.src='../../../assets/img/NoImg.png'"/>
              <span (click)="navigateToBrandPage(brandData?.idBrand, brandData?.brandName)">{{ brandData?.brandName}} </span>
            </li>
          </ul>
        </mat-tab>
      
     
      </mat-tab-group>
    </div>
    </div>
  
    <div class="mr-10">
      <form class="d-flex">
        <div class="mr-10">


          <mat-form-field floatLabel="always" appearance="outline" class="mog3_matinput autocomplete-search w-p143">

            <input type="text" (value)="onCategoryFilterChange($event.option.value)" (keydown.enter)="preventMenu(categoryMenu)" matInput
              [matAutocomplete]="categoryAuto" placeholder="Category Search" [formControl]="searchControl" (keydown.enter)="onSearchFilterChange($event)"/>
            <i class="ri-arrow-down-s-fill"></i>
            <mat-autocomplete class="autocomplete-menu" #categoryAuto="matAutocomplete"
              (optionSelected)="onCategoryFilterChange($event.option.value)">
              <mat-option *ngFor="let category of filteredCategories" [value]="category">
                {{ category.categoryName }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="mr-10">
          <button (focus)="focusMenuBrand()" class="header-search-filter-btn" #menuTrigger="matMenuTrigger" mat-button  [matMenuTriggerFor]="menu">
        
              <span *ngIf="selectedBrands?.length===0">Brand Search</span> 
            <i class="ri-arrow-drop-down-fill"></i>
            <span class="text-black" *ngIf="selectedBrands?.length!==0">{{getSelectedBrands(true)}}</span>
          </button>
          <mat-menu #menu="matMenu" class="header-menu-dropdown">
            <div (click)="$event.stopPropagation()">


              <mat-form-field class="mog3_matinput" appearance="outline">
                <input #myMenu type="text" placeholder="Enter brand name(min 3 characters)" aria-label="Number" matInput
                  [formControl]="searchBrandControl" (focus)="onInputFocus($event)" (keydown.enter)="onSearchFilterChange($event)" />
              </mat-form-field>
              <label class="line-after-2 line-after-button"><span>Selected Brands</span>
                <a (click)="clearSelectedBrands()">Clear all</a>
              </label>
              <ul class="selected-category-list">
                <li *ngFor="let selectedCategory of selectedBrands;let i=index">
                  <div class="selected-category-chip">
                    <span class="selected-category-label"> {{selectedCategory.brandName}} </span>
                    <span class="icon" (click)="deleteSelectedCat(selectedCategory,i)"><i
                        class="ri-close-circle-line"></i></span>
                  </div>
                </li>
              </ul>
              <label class="line-after-2"><span>Popular Search</span></label>
              <mat-selection-list>
                <mat-list-option *ngFor="let brand of filteredBrands" [value]="brand"
                  [selected]="selectedBrands.includes(brand)" (click)="onBrandSelectionChange(brand)" (keydown)="handleSpaceKey($event,categoryMenu)">
                  <span class="ml-10">{{ brand.brandName }}</span>
                </mat-list-option>
              </mat-selection-list>
            </div>
          </mat-menu>
        </div>


        <mat-form-field appearance="outline" class="mog3_matinput autocomplete-search w-p240">
          <input type="text" matInput [value]="searchOpenString" (keydown.enter)="preventMenu(categoryMenu)" (input)="onOpenFilterChange($event.target.value)"
            placeholder="Enter Keywords..." [formControl]="searchOpenControl" (keydown.enter)="onSearchFilterChange($event)"/>
            <button mat-icon-button type="submit" class="submit-button" title="submit"
            (click)="onSearchFilterChange($event)">
            <i class="ri-search-line"></i>
          </button>
        </mat-form-field>


      
        <button mat-icon-button type="reset" class="refresh-button" title="Refresh" (click)="refresh()">
          <mat-icon>refresh</mat-icon>
        </button>
      </form>
    </div>

    <div class="topMenuBar">
      <ul class="topmenulist">
        <li class="userDetails">
          <div class="flagName">
            <img [src]="getCountryFlag(countryName | uppercase)" width="120" />

            <span *ngIf="parentBusinessName; else elseblock">{{ username }} ({{ parentBusinessName }})</span>
            <ng-template #elseblock><span>{{username}} ({{countryName}})</span></ng-template>
          </div>
        </li>
        <li class="logout" (click)="logout()">
          <span class="material-icons">logout</span>
        </li>
      </ul>
    </div>
  </div>
</header>